/* RF Modal Sync - Synchronisation des modals avec les swatches */
console.log('RF Modal Sync: Script chargé');

(function() {
  'use strict';
  
  console.log('RF Modal Sync: Fonction principale exécutée');
  
  // Fonction pour mettre à jour tous les modals ouverts
  function updateAllOpenModals(swatch) {
    console.log('RF Modal Sync: Mise à jour des modals avec swatch:', swatch);
    
    // Trouver tous les modals ouverts
    const openModals = [...document.querySelectorAll('.quick-buy-modal, dialog.quick-buy-modal, [class*="modal"], [class*="quick-buy"], dialog')]
      .filter(m => {
        if (!m) return false;
        
        // Vérifier si le modal est visible
        const style = getComputedStyle(m);
        const isVisible = style.display !== 'none' && 
                         style.visibility !== 'hidden' && 
                         style.opacity !== '0' &&
                         m.offsetWidth > 0 && 
                         m.offsetHeight > 0;
        
        // Vérifier si le modal est ouvert
        const isOpen = m.hasAttribute('open') || 
                      m.classList.contains('open') || 
                      m.classList.contains('active') ||
                      m.classList.contains('visible');
        
        // Vérifier si le modal a du contenu visible
        const hasContent = m.querySelector('.product-title, .modal-title, h1, h2, h3, [class*="title"]') !== null;
        
        console.log('RF Modal Sync: Modal check:', {
          element: m,
          tagName: m.tagName,
          className: m.className,
          isVisible,
          isOpen,
          hasOpenAttr: m.hasAttribute('open'),
          openValue: m.getAttribute('open'),
          hasContent
        });
        
        // Inclure le modal s'il a l'attribut open ET du contenu
        const shouldInclude = m.hasAttribute('open') && hasContent;
        console.log('RF Modal Sync: Should include modal:', shouldInclude, 'width:', m.offsetWidth, 'height:', m.offsetHeight);
        
        return shouldInclude;
      });
    
    console.log('RF Modal Sync: Modals ouverts trouvés:', openModals.length);
    
    // Debug: Lister tous les modals dans le DOM
    const allModals = document.querySelectorAll('[class*="modal"], [class*="quick-buy"], dialog, quick-buy-modal');
    console.log('RF Modal Sync: Tous les modals dans le DOM:', allModals.length);
    allModals.forEach((modal, index) => {
      const style = getComputedStyle(modal);
      console.log(`RF Modal Sync: Modal ${index}:`, {
        tagName: modal.tagName,
        className: modal.className,
        id: modal.id,
        display: style.display,
        visibility: style.visibility,
        opacity: style.opacity,
        width: modal.offsetWidth,
        height: modal.offsetHeight,
        hasOpen: modal.hasAttribute('open'),
        openValue: modal.getAttribute('open'),
        attributes: Array.from(modal.attributes).map(attr => `${attr.name}="${attr.value}"`).join(', ')
      });
    });
    
    openModals.forEach(modal => {
      console.log('RF Modal Sync: Mise à jour du modal:', modal);
      
      // Mettre à jour le titre
      const titleEl = modal.querySelector('.product-title, .modal-title, h1, h2, h3, [class*="title"]');
      if (titleEl && swatch) {
        const productTitle = swatch.getAttribute('data-product-title');
        if (productTitle) {
          titleEl.textContent = productTitle;
          console.log('RF Modal Sync: Titre mis à jour vers:', productTitle);
        }
      }
      
      // Mettre à jour la couleur
      const colorEl = modal.querySelector('.rf-qb__color, .product-color, [class*="color"]');
      if (colorEl && swatch) {
        const colorHex = swatch.getAttribute('data-color-hex');
        const colorName = swatch.getAttribute('data-color-name');
        if (colorHex && colorName) {
          colorEl.innerHTML = `
            <div class="rf-qb__color-info">
              <div class="rf-qb__color-swatch" style="background-color: ${colorHex}"></div>
              <span class="rf-qb__color-name">${colorName}</span>
            </div>
          `;
          console.log('RF Modal Sync: Couleur mise à jour vers:', colorName, colorHex);
        }
      }
      
      // Mettre à jour les tailles
      const sizesRow = modal.querySelector('.rf-qb__sizes-row, [class*="sizes"]');
      if (sizesRow && swatch) {
        const sizesJson = swatch.getAttribute('data-sizes');
        const sizeIdsJson = swatch.getAttribute('data-size-ids');
        const sizeAvailableJson = swatch.getAttribute('data-size-available');
        
        if (sizesJson && sizeIdsJson && sizeAvailableJson) {
          try {
            const sizes = JSON.parse(sizesJson);
            const sizeIds = JSON.parse(sizeIdsJson);
            const sizeAvailable = JSON.parse(sizeAvailableJson);
            
            console.log('RF Modal Sync: Tailles trouvées:', sizes);
            
            // Vider la ligne des tailles
            sizesRow.innerHTML = '';
            
            // Créer les boutons de taille
            sizes.forEach((size, index) => {
              const isAvailable = sizeAvailable[index];
              const variantId = sizeIds[index];
              
              const sizeBtn = document.createElement('button');
              sizeBtn.type = 'button';
              sizeBtn.className = `rf-qb__size ${isAvailable ? 'rf-qb__size--available' : 'rf-qb__size--unavailable'}`;
              sizeBtn.textContent = size;
              sizeBtn.disabled = !isAvailable;
              
              if (isAvailable && variantId) {
                sizeBtn.setAttribute('data-variant-id', variantId);
                sizeBtn.addEventListener('click', () => {
                  // Mettre à jour le bouton CTA
                  const cta = modal.querySelector('.rf-qb__cta');
                  if (cta) {
                    cta.disabled = false;
                    cta.classList.add('rf-qb__cta--ready');
                    cta.textContent = 'Ajouter au panier';
                    cta.setAttribute('data-variant-id', variantId);
                  }
                  
                  // Désélectionner les autres tailles
                  sizesRow.querySelectorAll('.rf-qb__size').forEach(btn => {
                    btn.classList.remove('rf-qb__size--selected');
                  });
                  
                  // Sélectionner cette taille
                  sizeBtn.classList.add('rf-qb__size--selected');
                });
              }
              
              sizesRow.appendChild(sizeBtn);
            });
            
            console.log('RF Modal Sync: Tailles mises à jour');
          } catch (error) {
            console.error('RF Modal Sync: Erreur parsing JSON tailles:', error);
          }
        }
      }
    });
  }
  
  // Écouter les clics sur les swatches
  document.addEventListener('click', (e) => {
    const swatch = e.target.closest('.card-color-swatch__link');
    if (swatch && !swatch.closest('.quick-buy-modal')) {
      console.log('RF Modal Sync: Swatch cliquée, rechargement du modal...');
      
      // Récupérer les données du nouveau produit depuis la swatch
      const productHandle = swatch.getAttribute('data-product-handle');
      const variantId = swatch.getAttribute('data-variant-id');
      
      if (!productHandle || !variantId) {
        console.log('RF Modal Sync: Données manquantes - handle:', productHandle, 'variant:', variantId);
        return;
      }
      
      console.log('RF Modal Sync: Rechargement vers:', productHandle, 'variant:', variantId);
      
      // Utiliser l'utilitaire rfGetOpenQuickBuyModal pour détecter le modal ouvert
      const openModal = window.rfGetOpenQuickBuyModal ? window.rfGetOpenQuickBuyModal() : null;
      if (!openModal) {
        console.log('RF Modal Sync: Aucun modal ouvert trouvé avec rfGetOpenQuickBuyModal');
        
        // Fallback : essayer d'autres méthodes de détection
        const visibleModals = document.querySelectorAll('quick-buy-modal, .quick-buy-modal, dialog');
        console.log('RF Modal Sync: Modals visibles trouvés:', visibleModals.length);
        
        visibleModals.forEach((modal, index) => {
          const isVisible = modal.offsetWidth > 0 && modal.offsetHeight > 0;
          const hasExpanded = modal.getAttribute('aria-expanded') === 'true';
          const hasOpen = modal.hasAttribute('open');
          const style = window.getComputedStyle(modal);
          
          console.log(`RF Modal Sync: Modal ${index}:`, {
            tagName: modal.tagName,
            className: modal.className,
            isVisible,
            hasExpanded,
            hasOpen,
            display: style.display,
            visibility: style.visibility,
            opacity: style.opacity
          });
        });
        
        return;
      }
      
      console.log('RF Modal Sync: Modal ouvert trouvé:', openModal);
      
      // Mettre à jour le handle du modal
      const newHandle = `${productHandle}?variant=${variantId}`;
      openModal.setAttribute('handle', newHandle);
      console.log('RF Modal Sync: Handle mis à jour vers:', newHandle);
      
      // Recharger le contenu du modal
      if (openModal.show && typeof openModal.show === 'function') {
        console.log('RF Modal Sync: Rechargement du contenu via show()...');
        openModal.show();
      } else {
        console.log('RF Modal Sync: Méthode show non disponible, tentative de rechargement manuel...');
        
        // Rechargement manuel si la méthode show n'est pas disponible
        fetch(`${window.Shopify.routes.root}products/${productHandle}`)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const quickBuyContent = doc.getElementById('quick-buy-content');
            
            if (quickBuyContent && quickBuyContent.content) {
              // Nettoyer le contenu
              Array.from(quickBuyContent.content.querySelectorAll('noscript')).forEach(noScript => noScript.remove());
              
              // Remplacer le contenu
              openModal.replaceChildren(quickBuyContent.content);
              console.log('RF Modal Sync: Contenu rechargé manuellement');
              
              // Forcer le rechargement du composant rf-quick-buy.js
              setTimeout(() => {
                if (window.rfQuickBuyEnhanceAll) {
                  window.rfQuickBuyEnhanceAll();
                }
              }, 100);
            }
          })
          .catch(error => {
            console.error('RF Modal Sync: Erreur lors du rechargement:', error);
          });
      }
    }
  });
  
  // Écouter l'événement personnalisé rf:swatch-selected
  window.addEventListener('rf:swatch-selected', (e) => {
    console.log('RF Modal Sync: Événement rf:swatch-selected reçu:', e.detail);
    const swatch = e.detail.swatch;
    if (swatch) {
      setTimeout(() => {
        updateAllOpenModals(swatch);
      }, 100);
    }
  });
  
  console.log('RF Modal Sync: Initialisation terminée');
  
})();

/* RF Modal Sync Fixed: $(date +%s) */
/* DEBUG ALL MODALS: 1755785278 */
/* FIX MODAL DETECTION: 1755785356 */
/* FORCE UPDATE ALL MODALS: 1755785431 */
/* RELOAD MODAL CONTENT: 1755785627 */
/* FIX ARIA-EXPANDED DETECTION: 1755785724 */
/* FIX MODAL DETECTION SPECIFIC: 1755785852 */
/* ADD COLOR ATTRIBUTES TO SWATCHES: 1755786007 */
/* EXPOSE RF FUNCTIONS GLOBALLY: 1755787098 */
